/* IntelApps — Pricing Page */
import React, { useEffect } from 'react';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import DiscussCTA from '../parts/Discuss.js';
import FAQSection from '../parts/FAQ.js';

const PRICING = [
  {
    name: 'MVP',
    price: '$25K–50K',
    timeline: '8–12 weeks',
    desc: 'Core features, one platform, fast validation.',
    features: ['Senior engineer + designer', 'Weekly demos', 'Staging access', 'Source code ownership', '30-day warranty', 'Basic documentation'],
    cta: 'Get a quote',
    featured: false,
  },
  {
    name: 'Product',
    price: '$50K–150K',
    timeline: '12–20 weeks',
    desc: 'Full product launch with advanced features.',
    features: ['Everything in MVP', 'Advanced features', 'Multiple platforms', 'PM included', 'QA & load testing', 'Analytics setup', 'Deploy & monitoring'],
    cta: 'Get a quote',
    featured: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    timeline: '16+ weeks',
    desc: 'Dedicated team for complex initiatives.',
    features: ['Everything in Product', 'Dedicated team', '24/7 support SLA', 'Security review', 'Compliance help', 'Custom integrations', 'Ongoing partnership'],
    cta: 'Contact us',
    featured: false,
  },
];

export default function PricingPage() {
  useEffect(() => { document.title = 'IntelApps — Pricing'; }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container page-hero-grid">
            <div>
              <span className="eyebrow">Pricing</span>
              <h1>Transparent pricing. No surprises.</h1>
              <p className="page-hero-sub">Fixed-fee engagements. You know exactly what you&apos;re getting, before we start work.</p>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="pricing-grid">
              {PRICING.map((plan) => (
                <div key={plan.name} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <p
                        style={{
                          fontFamily: 'JetBrains Mono, monospace',
                          fontSize: '11px',
                          color: 'var(--ink-4)',
                          textTransform: 'uppercase',
                          letterSpacing: '0.08em',
                        }}
                      >
                        {plan.timeline}
                      </p>
                      <h3 style={{ fontSize: '24px', fontWeight: 700, margin: '8px 0' }}>{plan.name}</h3>
                    </div>
                  </div>
                  <p className="pricing-price">{plan.price}<span>/project</span></p>
                  <p style={{ color: 'var(--ink-3)', fontSize: '15px', lineHeight: 1.5 }}>{plan.desc}</p>
                  <ul className="pricing-features">
                    {plan.features.map((f) => <li key={`${plan.name}-${f}`}>{f}</li>)}
                  </ul>
                  <a href="/discuss-project" className={`btn ${plan.featured ? 'btn-accent' : 'btn-ghost'}`} style={{ width: '100%', justifyContent: 'center', marginTop: 'auto' }}>{plan.cta}</a>
                </div>
              ))}
            </div>
            <div
              style={{
                marginTop: '48px',
                textAlign: 'center',
                color: 'var(--ink-3)',
                fontSize: '14px',
              }}
            >
              <p style={{ marginBottom: '8px' }}>All plans include source code ownership and deployment assistance.</p>
              <p>
                Need something different?{' '}
                <a href="/discuss-project" style={{ color: 'var(--accent)', textDecoration: 'underline' }}>
                  Let&apos;s talk.
                </a>
              </p>
            </div>
          </div>
        </section>
        <FAQSection />
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
